var map = {
	"./cedel2": 570,
	"./cedel2.png": 570,
	"./feder": 571,
	"./feder.png": 571,
	"./minci": 572,
	"./minci.png": 572,
	"./minec": 573,
	"./minec.png": 573,
	"./mineco": 574,
	"./mineco.png": 574,
	"./search": 575,
	"./search.png": 575,
	"./simple_search": 576,
	"./simple_search.png": 576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 583;